<app-button
  label="Adicionar mais itens"
  layout="button-more-items w-100 w-md-25 button-border button-size-auto"
  variant="transparent"
  (buttonClick)="onMoreItems()">
</app-button>
